/**
 * Quotes Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initQuotes() {
        const blocks = document.querySelectorAll('.quotes');
        
        blocks.forEach(block => {
            // Initialize read more/less functionality
            initReadMore(block);
        });
    }
    
    /**
     * Initialize read more/less accordion functionality
     */
    function initReadMore(block) {
        const toggles = block.querySelectorAll('.read-more-toggle');
        
        toggles.forEach(toggle => {
            toggle.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                const titleWrapper = this.closest('.title-wrapper');
                const title = titleWrapper.querySelector('.quote_title');
                const shortText = title.querySelector('.title-short');
                const fullText = title.querySelector('.title-full');
                const shortButton = shortText ? shortText.querySelector('.read-more-toggle') : null;
                const fullButton = fullText ? fullText.querySelector('.read-more-toggle') : null;
                const isExpanded = this.getAttribute('aria-expanded') === 'true';
                
                if (isExpanded) {
                    // Collapse
                    title.classList.add('collapsing');
                    setTimeout(() => {
                        if (shortText) shortText.style.display = 'inline';
                        if (fullText) fullText.style.display = 'none';
                        title.classList.remove('expanded', 'collapsing');
                        if (shortButton) {
                            shortButton.setAttribute('aria-expanded', 'false');
                            const shortReadMore = shortButton.querySelector('.read-more-text');
                            const shortReadLess = shortButton.querySelector('.read-less-text');
                            if (shortReadMore) shortReadMore.style.display = 'inline';
                            if (shortReadLess) shortReadLess.style.display = 'none';
                        }
                    }, 10);
                } else {
                    // Expand
                    title.classList.add('expanding');
                    if (shortText) shortText.style.display = 'none';
                    if (fullText) fullText.style.display = 'inline';
                    if (fullButton) {
                        fullButton.setAttribute('aria-expanded', 'true');
                        const fullReadMore = fullButton.querySelector('.read-more-text');
                        const fullReadLess = fullButton.querySelector('.read-less-text');
                        if (fullReadMore) fullReadMore.style.display = 'none';
                        if (fullReadLess) fullReadLess.style.display = 'inline';
                    }
                    
                    // Trigger reflow for animation
                    title.offsetHeight;
                    
                    title.classList.remove('expanding');
                    title.classList.add('expanded');
                }
            });
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initQuotes);
    } else {
        initQuotes();
    }
})();